import { render } from "./QuizGameWorld.vue?vue&type=template&id=fabee3c4&scoped=true"
import script from "./QuizGameWorld.vue?vue&type=script&lang=js"
export * from "./QuizGameWorld.vue?vue&type=script&lang=js"

import "./QuizGameWorld.vue?vue&type=style&index=0&id=fabee3c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabee3c4"]])

export default __exports__